module.exports = __webpack_public_path__ + "img/generali.61c9977c.webp";